import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'company'],

    data() {
        return {
            tab: 0,
            showImageHolder: false,
            selectedImagePreview: null,
            selectedImage: null,
            title: '',
            companyImage: null,
            archive: false,
            buttonTitle: '',
            isLoading: false,
            usingVouchers: false,
            name: '',
            internalName: '',
            visibleForCustomer: false,
            lat: 0.0,
            lng: 0.0,
            phoneNumber: '',
            hasError: '',
            info: {
                name: '',
                email: '',
                address: '',
                zip: '',
                city: '',
                pib: '',
                mb: '',
            },
            discounts: {
                city: 0
            }
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedImagePreview = null;
                this.selectedImage = null;
                if(this.company == null){
                    this.title = 'Dodaj kompaniju'
                    this.buttonTitle = 'Dodaj';
                    this.showImageHolder = false;
                    this.usingVouchers = false;
                    this.name = '';
                    this.internalName = '';
                    this.visibleForCustomer = true;
                    this.phoneNumber = '';
                    this.companyImage = null;
                    this.lat = 0;
                    this.lng = 0;
                    this.info = {
                        name: '',
                        email: '',
                        address: '',
                        zip: '',
                        city: '',
                        pib: '',
                        mb: '',
                    }
                    this.discounts = {
                        city: 0
                    }
                }else{
                    this.title = 'Izmeni kompaniju: ' + this.company.name;
                    this.buttonTitle = 'Izmeni';
                    this.showImageHolder = true;
                    this.companyImage = this.company.profileImageUrl == null ? null : (this.company.profileImageUrl + "?" + new Date().getTime());
                    this.usingVouchers = this.company.usingVouchers;
                    this.name = this.company.name;
                    this.internalName = this.company.internalName != null ? this.company.internalName: '';
                    this.archive = this.internalName.includes("_archive_")
                    this.internalName = this.internalName.replace("_archive_", "")
                    this.visibleForCustomer = this.company.visibleForCustomer != null ? this.company.visibleForCustomer: true;
                    this.phoneNumber = this.company.phoneNumber == null ? '' : this.company.phoneNumber;
                    this.lat = this.company.address.lat;
                    this.lng = this.company.address.lng;
                    this.info = {
                        name: this.company.info != null && this.company.info.name != null ? this.company.info.name : '',
                        email: this.company.info != null && this.company.info.email != null ? this.company.info.email : '',
                        address: this.company.info != null && this.company.info.address != null ? this.company.info.address : '',
                        zip: this.company.info != null && this.company.info.zip != null ? this.company.info.zip : '',
                        city: this.company.info != null && this.company.info.city != null ? this.company.info.city : '',
                        pib: this.company.info != null && this.company.info.pib != null ? this.company.info.pib : '',
                        mb: this.company.info != null && this.company.info.mb != null ? this.company.info.mb : '',
                    }
                    this.discounts = {
                        city: this.company.discounts != null && this.company.discounts.city != null ? this.company.discounts.city : 0
                    }

                }
            }
        },
        name: function(val, oldVal) {
            this.hasError = '';
        },
        lat: function(val, oldVal) {
            this.hasError = '';
        },
        lng: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeAddCompany')
        },
        successUpdate(){
            this.reset();
            this.$topnavbar.$emit('successAddCompany')
        },

        addCompany: addCompany,
        deleteSelectedImage: deleteSelectedImage,
        uploadImage: uploadImage,
        loadTextFromFile: loadTextFromFile,
        getModuleStyle: getModuleStyle,
        setTab: setTab,
        editCompany: editCompany,
        reset: reset,
    },

    beforeMount() {
    }
}

function deleteSelectedImage(){
    this.selectedImage = null;
    this.selectedImagePreview =  null;
}

function loadTextFromFile(ev){
    var i = 0;
    for(i = 0; i< ev.target.files.length; i++){
        const file = ev.target.files[i];
        if(file.size > 5000000){
            alert('Maximalna veličina fajla je 5 MB')
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}

function setTab(index){
    this.tab = index
}

function editCompany() {
    let _self = this;
    //set archive
    if(this.archive){
        if(!_self.internalName.includes("_archive_")){
            _self.internalName = _self.internalName+"_archive_"
        }
    }else{
        _self.internalName = _self.internalName.replace("_archive_", "")
    }
    const newModel = {
        name: _self.name,
        internalName: _self.internalName,
        visibleForCustomer: _self.visibleForCustomer,
        phoneNumber: _self.phoneNumber,
        lat: parseFloat(_self.lat),
        lng: parseFloat(_self.lng),
        usingVouchers: _self.usingVouchers,
        info: _self.info,
        discounts: {
            city: this.discounts.city != null ? parseFloat(this.discounts.city) : 0
        }
    };
    _self.isLoading = true;
    AdminApiService.editCompany(newModel, _self.company.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })
}

function addCompany() {
    if(this.name.length === 0 ||
        this.lat === 0.0 ||
        this.lat.length === 0 ||
        this.lng.length === 0 ||
        this.lng === 0.0 ) {
        this.hasError = "Molimo popunite sva polja";
        return;
    }
    if(this.company != null){
        this.editCompany();
        return;
    }
    let _self = this;
    const newModel = {
        name: _self.name,
        internalName: _self.internalName,
        visibleForCustomer: _self.visibleForCustomer,
        phoneNumber: _self.phoneNumber,
        lat: parseFloat(_self.lat),
        lng: parseFloat(_self.lng),
        usingVouchers: _self.usingVouchers,
        info: _self.info,
        discounts: {
            city: this.discounts.city != null ? parseFloat(this.discounts.city) : 0
        }
    };
    _self.isLoading = true;
    AdminApiService.createCompany(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function uploadImage(){
    if(this.selectedImage == null){
        this.addCompany();
        return
    }

    let _self = this;
    _self.isLoading = true;
    AdminApiService.uploadImage(this.company.id, this.selectedImage)
        .then((response) => {
            _self.isLoading = false;
           _self.addCompany();
        })
        .catch((error) => {
            _self.isLoading = false;
            _self.hasError = "Greška prilikom upload-a slike."
        })
}

function reset() {
    this.name = '';
    this.lat = 0.0;
    this.lng = 0.0;
    this.phoneNumber = '';
    this.internalName = '';
    this.usingVouchers = false;
    this.visibleForCustomer = false;
    this.selectedImage = null;
    this.selectedImagePreview = null;
    this.info = {
        name: '',
        email: '',
        address: '',
        zip: '',
        city: '',
        pib: '',
        mb: '',
    }
    this.discounts = {
        city: 0
    }
    this.tab = 0;
}


function getModuleStyle(index) {
    if(index === this.tab){
        return "background: #70b1e7; color: white;"
    }else {
        return "background: white; color: black; border: white;"
    }
}


// WEBPACK FOOTER //
// ./src/modals/AddCompanyModal.js